import { createFileRoute, notFound, Outlet } from '@tanstack/react-router';
import type { ErrorComponentProps } from '@tanstack/react-router';

import { loadLocationRoute } from 'shared/modules/locations';

import { LocationError } from 'features/errors';

const LocationErrorComponent = (props: ErrorComponentProps) => {
  const { id } = Route.useParams();

  return <LocationError {...props} locationId={id} />;
};

export const Route = createFileRoute('/_authenticated/locations/$id')({
  parseParams: ({ id }) => ({ id: parseInt(id, 10) }),
  stringifyParams: ({ id }) => ({ id: String(id) }),
  staticData: { breadcrumb: 'location' },
  // A non-numeric id is a 404. `notFound()` stops the match chain here: no child
  // `beforeLoad` runs and no loader calls the API.
  beforeLoad: ({ params: { id } }) => {
    if (Number.isNaN(id)) {
      throw notFound();
    }
  },
  loader: ({ context: { queryClient, authUser }, params: { id } }) =>
    loadLocationRoute({ queryClient, locationId: id, userId: authUser.user.userId }),
  errorComponent: LocationErrorComponent,
  component: () => <Outlet />
});
